<template>
    <el-dialog
        :title=titele
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form >
         <div class="fuzzy-matching-bottom">
           <el-row class="list">
             <el-table
                :border="true"
                :header-cell-style="{background:'#EDF6FF',color:'#000',}"
                style="width: 100%"
                :data="tableData"
             >
              <el-table-column
                prop="mobile"
                label="手机号"
                >
              </el-table-column>
                <el-table-column
                label='关系'
                >
                <template #default="scope">
                  <div class="shanchuBtn" type="text" size="small"  style="color:red">{{scope.row.relation }}</div>
                  <div class="shanchuBtn" type="text" size="small" >{{  scope.row.time }}</div>

                </template>
              </el-table-column>
              <el-table-column
                label="微信"
                >
                <template #default="scope">
                  <!-- <div class="shanchuBtn" type="text" size="small" ><img src=" scope.row.nickname" alt=""></div> -->
                  <img v-if="scope.row.logo != null" :src="scope.row.logo" alt="" style="height: 30px; width: 30px;">
                  <div class="shanchuBtn" type="text" size="small" >{{  scope.row.nickname }}</div>

                </template>
              </el-table-column>

              <!-- <el-table-column
                label="操作"
                >
                <template #default="scope">
                  <el-button class="shanchuBtn" type="text" size="small" @click="deleteClick(scope.row)" >删除</el-button>

                </template>
              </el-table-column> -->

            </el-table>
          </el-row>

    </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { StudentBindInfo} from '@/assets/api/renyuan.js'
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['PeopleObj'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            form:{
                imei:'',
            },
            cardid:"",
            tableData:[],
            titele:""
          
        }

    },
    created(){
       
    },
    mounted(){
        this.deviceClick()
        this.titele = this.PeopleObj.studentName + '的绑定关系'


    },
    methods:{
        handleClose() {
            this.$emit('closeClick')
      },
    deviceClick(){
        // const params  = {
        //     imei:
        // }
        StudentBindInfo(this.PeopleObj.imei).then((res)=> {
        console.log(res.data.data,'查询');
        this.tableData = [res.data.data]
        console.log(this.PeopleObj,'查询222');

        // this.
        // this.$message({
        //             type: 'success',
        //             message: '换机成功'
        //         });
        // this.loading = false
        // this.handleClose()
        }).catch((err)=> {
            console.log(err,'查询');
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
          })
      }
    }
    }




</script>
<style  scoped lang="scss">
    /deep/ {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        // margin-left: 180px;


    }
    .el-table--small .cell{
          text-align: center;
        }
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>